module.exports = __webpack_public_path__ + "static/media/Arya Stark 2.69dbbd52.jpg";